import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store/';
import utils from '@/utils/';

import Auth from './Auth';
import Personal from './Personal';
import Product from './Product';
import Board from './Board';
import User from './User';
import Policy from './Policy';

Vue.use(VueRouter);

const routes = [
  { path: '/', redirect: '/product/' },
  ...Auth,
  Personal,
  Product,
  Board,
  User,
  Policy,
];

const router = new VueRouter({
  routes,
});

// 認証レベルに応じてログイン画面に戻す
router.beforeEach((to, from, next) => {
  // ページ表示に必要な認証レベル
  const pageLevel = to.matched.reduce((acc, cur) => {
    if (cur.meta.level === undefined || cur.meta.level === null) {
      return acc;
    }
    return cur.meta.level;
  }, 1);

  // ログイン認証
  if (pageLevel > 0) {
    if (store.state.auth.level > 0) {
      if (store.state.auth.level >= pageLevel) {
        // 充分な認証レベル
        next();
      } else {
        // 認証レベルが不足
        utils.error('level');
        next({ path: '/auth/login', query: { redirect: to.fullPath } });
      }
    } else {
      // ログインされていない(ログイン画面に戻す)
      utils.error('login');
      next({ path: '/auth/login', query: { redirect: to.fullPath } });
    }
  } else {
    // ログイン不要
    next();
  }
});

export default router;
